const ApiTypes = {
  // Ping test
  PING_REQUEST: "PING_REQUEST",
  PING_SUCCESS: "PING_SUCCESS",
  PING_FAILURE: "PING_FAILURE",
  
  // User info
  GET_USER_INFO: "GET_USER_INFO",
  GET_USER_INFO_SUCCESS: "GET_USER_INFO_SUCCESS",
  GET_USER_INFO_FAILURE: "GET_USER_INFO_FAILURE",
};

export default ApiTypes;
